// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".photo-view .photo-view-item{border-radius:5px;border:1px solid hsla(0,0%,49.4%,.2);position:relative;margin:0 5px 5px 0}.photo-view .photo-view-item img{max-width:100%;max-height:100%}.photo-view .photo-view-item i{position:absolute;right:5px;top:5px;display:none}.photo-view .photo-view-item:hover i{display:block}", ""]);
// Exports
module.exports = exports;
